/** H5 站内法律文档路径；未配置 REACT_APP_LEGAL_WEB_ORIGIN 时使用 /legal/... 路由 */
export function h5LegalUrl(slug: string): string {
  const base = process.env.REACT_APP_LEGAL_WEB_ORIGIN?.trim();
  if (base) {
    return `${base.replace(/\/$/, "")}/legal/${slug}`;
  }
  return `/legal/${slug}`;
}
